// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3usql","newExpiryDate":"styles_newExpiryDate__12nuO","footer":"styles_footer__bK8sz"};